






































































































import { Component, Vue } from 'vue-property-decorator'
import { RepaymentPageRecord } from '@/api/model/repayment'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import $Api from '@api'
import { DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'

@Component({
    components: {
        SearchForm,
        TableForm
    }
})
export default class extends Vue {
    tableData: RepaymentPageRecord[] = []

    shouldTableDataLoading = false
    shouldLoading = false

    created(): void {
        this.getData()
    }

    getData(): void {
        const { lid } = this.$route.query
        this.shouldTableDataLoading = true
        $Api.repaymentService
            .repaymentList({
                lid: +lid
            })
            .pipe(
                finalize(() => {
                    this.shouldTableDataLoading = false
                })
            )
            .subscribe(res => {
                this.tableData = res
            })
    }

    viewLoanDetail(row: RepaymentPageRecord): void {
        const query = {
            index: String(row.indexs),
            lid: String(row.lid),
            rid: String(row.rid)
        }
        this.$router.push({ name: 'loan/unpaid-detail', query })
    }

    dateTime(time) {
        if (time) return DateTime(time)
        return ''
    }
}
